module.exports = __webpack_public_path__ + "files/b29726fc8b7bdae18737130602c33c18.png";